import { Component, EventEmitter, Input, Output } from "@angular/core";
import { PcpItem } from "@core/interfaces/3rdparty/pcp/v3/pcp-item";

@Component({
    selector: "app-pcp-item-v3",
    templateUrl: "./pcp-item.component.html",
    styleUrls: ["./pcp-item.component.scss"],
    standalone: false,
})
export class PcpItemComponent {
    @Input() listItem = true;
    @Input() pcpInfo: PcpItem;

    @Output() itemSelected = new EventEmitter();
    @Output() itemRemoved = new EventEmitter();

    public readonly translationPrefix = "common.pcpItem";

    constructor() {}

    emitItemSelected() {
        this.itemSelected.emit(this.pcpInfo);
    }

    emitItemRemoved() {
        this.itemRemoved.emit();
    }
}
